import { render, staticRenderFns } from "./purorderdetailview.vue?vue&type=template&id=2f85bb6a&scoped=true&"
import script from "./purorderdetailview.vue?vue&type=script&lang=js&"
export * from "./purorderdetailview.vue?vue&type=script&lang=js&"
import style0 from "./purorderdetailview.vue?vue&type=style&index=0&id=2f85bb6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f85bb6a",
  null
  
)

export default component.exports